import { render, staticRenderFns } from "./SendTick.vue?vue&type=template&id=2db69e01&"
import script from "./SendTick.vue?vue&type=script&lang=js&"
export * from "./SendTick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports